define('views/blocks/ProductSidedishCustomBox42View',['underscore', 'jquery', 'backbone', 'app',
        'views/blocks/ProductSidedishView',
        'views/blocks/MiniProductInfoView'
    ],
function(_,jQuery,BackBone,app,
         ProductSidedishView,
         MiniProductInfoView
){

    return ProductSidedishView.extend({
        events: {
        'click .sidedish-list-grouped__checkable':'checkInputs',
        'click .btn-quantity':'changeQuantity',
        'click .sidedish-custom-box__product':'productClick',
        'click .sidedish-custom-box__switch__button':'switchActiveSidedish',
        'click .sidedish-custom-box__sidedish__next':'nextActiveSidedish',
        'click .sidedish-custom-box__canvas':'onClickOnCanvas',
        'click .sidedish-custom-box__areas':'onClickOnCanvas',
        },
        start:function(){
            this.activeSidedish(0);
            this.draw();
        },
        draw:function(){
            var view = this,
                DPR = window.devicePixelRatio || 1,
                $canvas = view.$('.sidedish-custom-box__canvas'),
                canvas = $canvas.get(0),
                ctx = canvas ? canvas.getContext('2d') : false,
                sidedishParent = view.sidedish;
            if(!ctx) return;

            function drawItem(location,item){
                var w=184,h=276,
                    type=location.type,
                    baseType = type.replace(/\-div$/,''),
                    orientation = location.o,
                    horizontal = orientation==='h',
                    a = horizontal ? 90:0,
                    x = location.x,
                    y = location.y,
                    isDivided = /\-div$/.test(type),
                    sourceImage = item.img;
                if(isDivided){
                    w = 92;
                    if(baseType==='rolls'){
                        drawSingleItem(location.x_alt,y,w,h,a,sourceImage,isDivided);
                    }else{
                        drawSingleItem(x,location.y_alt,w,h,a,sourceImage,isDivided);
                    }
                }
                drawSingleItem(x,y,w,h,a,sourceImage,isDivided);
            }

            function drawSingleItem(x,y,w,h,a,sourceImage,isDivided){
                ctx.save();
                var dx = -w/2, dy = -h/2;
                ctx.translate(x, y);
                ctx.rotate(a * Math.PI / 180 );
                if(sourceImage){
                    var imgW = sourceImage.naturalWidth;
                    var imgH = sourceImage.naturalHeight,
                        sW = Math.round(imgW * (isDivided?1:2)/3),
                        sDx = isDivided?0:Math.round(imgW/3);
                    ctx.drawImage(sourceImage, sDx,0, sW, imgH, dx, dy, w, h );
                }
                ctx.restore();
            }

            // tri des emplacements par "z"
            var locationsSorted = _(_(sidedishParent.getLocations().sortBy('z')).reverse());

            // message général
            var validateSelection = sidedishParent.validateSelection(),
                rulesEl = view.$('.sidedish-custom-box__rules');
            view.$('.sidedish-custom-box__rules').text(sidedishParent.getRulesLabel());
            if(validateSelection){
                rulesEl.removeClass('warn');
            }

            function resetCanvas(){
                var stageW = canvas.width = canvas.height = Math.round($canvas.width() * DPR) || 0,
                    scale = stageW / 800;
                if(scale > 0){
                    ctx.resetTransform();
                    ctx.clearRect(0,0,stageW,stageW);
                    ctx.scale(scale,scale);
                }else{
                    setTimeout(resetCanvas,100);
                }
            }

            function draw(){
                var ready = true, drawingItems = 0;
                locationsSorted.each(function(l){delete l.item})
                sidedishParent.eachChildren(function(sidedishChild) {
                    var qtyMessageEl = view.$('.sidedish-'+sidedishChild.id+' .sidedish-custom-box__sidedish-max');
                    qtyMessageEl.text(sidedishChild.getRulesLabel());
                    if(sidedishChild.validateSelection()){
                        qtyMessageEl.removeClass('warn');
                    }
                    _(sidedishChild.getSelection()).each(function (item) {
                        ready = !!item.ready;
                        drawingItems ++;
                        if(!item.img){
                            try{
                                var product = item.p,
                                    imgUrl = product.getCustomProductPictureUrl();
                                var img = item.img = new Image();
                                img.addEventListener('load',function(){
                                    item.ready = true;
                                    draw();
                                });
                                img.src = imgUrl;
                            }catch(err){
                                app.error(err);
                            }
                        }
                    })
                });
                if(ready){
                    resetCanvas();
                    // on ne dessine que quand toutes les images sont chargées
                    view.$('.sidedish-custom-box__location').removeClass('selected');
                    sidedishParent.eachChildren(function(sidedishChild) {
                        _(sidedishChild.getSelection()).each(function (item) {
                            _(item.positions).each(function (positionId) {
                                view.$('.sidedish-custom-box__location[data-location='+positionId+']').addClass('selected');
                                var location = locationsSorted.findWhere({id: positionId});
                                if(location) location.item = item;
                            })
                        });
                    });
                    // l'ordre d'empilement est statique.
                    locationsSorted.each(function(location){
                        var item = location.item;
                        if(item) drawItem(location, item);
                    });
                }
                if(drawingItems===0){
                    resetCanvas();
                }
            }
            draw();

        },
        changeQuantity:function(e) {
            e.preventDefault();
            e.stopPropagation();
            var view = this,
            currentTarget = $(e.currentTarget),
            add = !currentTarget.hasClass('less'),
            currentProductEl = currentTarget.closest('.sidedish-custom-box__product'),
            id_product = currentProductEl.data('product').toString(),
            sidedishEl = currentTarget.closest('.sidedish-custom-box__sidedish'),
            sidedishId = sidedishEl.data('sidedish').toString(),
            sidedish = view.sidedish.getChild(sidedishId);
            sidedish.changeSelection(add,id_product);
            view.updateSidedishEl(sidedishEl,sidedish);
            view.updateButtonCTA(sidedish);
            view.draw();
        },
        productClick:function(e){
            if($(e.target).is('.quantity')){
                return;
            };
            var view = this,
                currentTarget = $(e.currentTarget),
                currentProductEl = currentTarget.closest('.sidedish-custom-box__product'),
                id_product = currentProductEl.data('product').toString(),
                sidedishEl = currentTarget.closest('.sidedish-custom-box__sidedish'),
                sidedishId = sidedishEl.data('sidedish').toString(),
                sidedish = view.sidedish.getChild(sidedishId);
          if(app.isMobile()) {
              view.displayMiniProductInfo(id_product,sidedish);
          }else if(sidedish.getCapability(id_product,'add') === 'yes' &&
            !$(e.target).is('.sidedish-custom-box__product-buttons')
          ){
              currentProductEl.find('.more').click();
          }
        },
        displayMiniProductInfo:function(id_product,sidedish){
            var view = this;
            var sidedishEl = view.$('sidedish-'+sidedish.id),
                sidedishMax = sidedish.getMaximum(),
                sidedishQuantity = sidedish.getSelectionQuantity(),
                productQuantity = sidedish.getSelectionQuantity(id_product),
                multiple_by_product = sidedish.getIsMultipleByProduct(),
                deltaQuantity = Math.min(sidedishMax - sidedishQuantity + productQuantity,sidedish.getMaximumProduct(id_product)),
                realMax = multiple_by_product ? deltaQuantity : 1,
                productImmutableQuantity = sidedish.getSelectionQuantity(id_product,true)
            var miniProductInfoView = new MiniProductInfoView({
                id_product: id_product,
                quantity: productQuantity,
                min: productImmutableQuantity,
                max: realMax,
                isFixedProduct:sidedish.isFixedProduct(id_product),
            });
            view.listenToOnce(miniProductInfoView, 'submit', function (quantity) {
                sidedish.updateSelection(quantity, id_product);
                view.updateSidedishEl(sidedishEl, sidedish);
                view.updateButtonCTA(sidedish);
                view.draw();
            });
            view.listenToOnce(miniProductInfoView, 'close', function(){
                view.stopListening(miniProductInfoView);
            });
            view.attachView(miniProductInfoView);
            app.displayModal(miniProductInfoView);
        },
        updateSidedishEl:function(sidedishEl,sidedish){
            var view = this;
            sidedishEl.find('.sidedish-custom-box__product').each(function(){
                var $el = view.$(this),
                    id_product = ''+$el.data('product'),
                    quantity = sidedish.getSelectionQuantity(id_product),
                    capAdd = sidedish.getCapability(id_product,'add'),
                    capRemove = sidedish.getCapability(id_product,'remove');
                $el.attr({
                    'data-cap-add':capAdd,
                    'data-cap-remove':capRemove,
                });
                $el.find('.quantity').attr('data-qty',quantity);
            });
            sidedishEl.attr({
                'data-cap-add':sidedish.getCapability(0,'add'),
                'data-cap-remove':sidedish.getCapability(0,'remove'),
            })
        },
        switchActiveSidedish:function(e) {
            e.preventDefault();
            this.activeSidedish($(e.currentTarget).index());
        },
        nextActiveSidedish:function(e) {
            e.preventDefault();
            var view = this,
                currentIndex = view.$('.sidedish-custom-box__sidedish.active').index();
            view.activeSidedish(currentIndex+1);
        },
        activeSidedish:function(index){
            var view = this;
            var children = view.sidedish.getChildren(),
                activeSidedish = children._wrapped[index];
            function ActiveIndex(i){
                $(this).toggleClass('active',i===index);
            }
            if(!activeSidedish){
                // réactivation vers le premier invalide.
                children.forEach(function(s,i){
                    if(!activeSidedish && !s.validateSelection()){
                        activeSidedish = s;
                        index = i;
                    }
                })
            }
            if(activeSidedish){
                view.$('.sidedish-custom-box__switch__button').each(ActiveIndex);
                view.$('.sidedish-custom-box__sidedish').each(ActiveIndex);
            }
            view.updateButtonCTA(activeSidedish);
        },
        updateButtonCTA:function(sidedish){
            var view = this, ctaEl = view.$('.sidedish-custom-box__sidedish__next');
            ctaEl.toggleClass('hidden',!!view.sidedish.validateSelection()); // global
            if(sidedish){
                var stepInvalid = !sidedish.validateSelection();
                ctaEl.text(sidedish.getRulesLabel());
                ctaEl.toggleClass('invalid',stepInvalid); // suivant l'étape active
                ctaEl.attr('disabled',stepInvalid);
            }
            view.trigger('change');
        },
        validate:function(){
            return this.sidedish.validateSelection();
        },
        warn:function(){
            var view = this, firstInvalid = false;
            view.$('.sidedish-custom-box__rules').addClass('warn');
            view.sidedish.eachChildren(function(sidedishChild,i) {
                var qtyMessageEl = view.$('.sidedish-'+sidedishChild.id+' .sidedish-custom-box__sidedish-max'),
                    valideStep = sidedishChild.validateSelection();
                if(!valideStep && firstInvalid===false){
                    firstInvalid = i;
                    if(app.isDesktop()){
                        app.scrollTop(qtyMessageEl.offset().top - 140,500);
                    }
                }
                qtyMessageEl.toggleClass('warn',!valideStep);
            });
            if(firstInvalid>=0){
                view.activeSidedish(firstInvalid);
            }
        },
        highlightProduct:function(id_cross_selling,id_product){
            var view = this,
                productEl = view.$('.sidedish-custom-box__product[data-product='+id_product+']'),
                scrollDest, scrollDiff;
            if(app.isDesktop()){
                scrollDest = productEl.offset().top - 210;
                scrollDiff = app.$window.scrollTop() != scrollDest;
                app.scrollTop(scrollDest,500);
                setTimeout(function(){
                    productEl.addClass('highlight')
                    setTimeout(function(){
                        productEl.removeClass('highlight')
                    },1200)
                },scrollDiff?500:0);
            }else{
                view.displayMiniProductInfo(id_product,view.sidedish.getChild(id_cross_selling));
            }
        },
        onClickOnCanvas:function(e){
            var view = this,
                sidedishParent = view.sidedish,
                locationsSorted = _(_(sidedishParent.getLocations().sortBy('z')).reverse()),
                canvas = view.$('canvas'),
                offset = canvas.offset(),
                canvasWidth = canvas.width(),
                scale = canvasWidth / 800,
                x = (e.pageX-offset.left) / scale,
                y = (e.pageY-offset.top) / scale;
            var selectedSidedish, selectedItem;
            locationsSorted.find(function(location){
                var matching = false;
                sidedishParent.eachChildren(function(sidedishChild) {
                    if(matching) return;
                    var selection = sidedishChild.getSelection();
                    matching = !! _(selection).find(function (item) {
                        return !! _(item.positions).find(function (positionId) {
                            //
                            if(location.id === positionId){
                                if(!!_(location.bounds).find(function(bounds){
                                    return x > bounds.left && x < bounds.right && y > bounds.top && y < bounds.bottom;
                                })){
                                    selectedSidedish = sidedishChild;
                                    selectedItem = item;
                                    return true;
                                }
                            }
                            return false;
                            //
                        })
                    });
                })
                return matching;
            });
            if(selectedSidedish && selectedItem && selectedItem.p){
                view.highlightProduct(selectedSidedish.id,selectedItem.p.id);
            }
        }

    })
});
